export type ErrorType = (
    'ERR8002' |
    'ERR7001' |
    'ERR7011' |
    'ERR7003' |
    'ERR_OTHER' |
    'ERR1027' |
    'ERR1028' |
    'ERR7021' |
    'ERR7022'
);

export class ErrorTypes {
    static readonly NonMatchingEmail: ErrorType = 'ERR8002';
    static readonly InvalidStatus: ErrorType = 'ERR7001';
    static readonly DocumentExpired: ErrorType = 'ERR7011';
    static readonly DocumentIdEmpty: ErrorType = 'ERR7003';
    static readonly ErrorOther: ErrorType = 'ERR_OTHER';
    static readonly NotFound: ErrorType = 'ERR1027';
    static readonly InvalidRequest: ErrorType = 'ERR1028';
    static readonly ApplicationApproved: ErrorType = 'ERR7021';
    static readonly ApplicationDeclined: ErrorType = 'ERR7022';
}



// WEBPACK FOOTER //
// ./src/models/Errors.ts